import React from "react";

export default function ErrorBar({
  children,
  className = "",
  headerText = "Statement processing error",
  ...props
}) {
  return (
    <div
      className={`rounded-3xl border border-[rgba(125,35,35,0.18)] bg-[#fdf4f4] p-6 shadow-[0_18px_36px_rgba(125,35,35,0.08)] ${className}`}
      {...props}
    >
      <p className="text-base font-semibold text-danger-700">
        {headerText}
      </p>
      <div className="mt-2 text-sm leading-relaxed text-danger-700">
        {children}
      </div>
    </div>
  );
}
